// Packages
import PropTypes from 'prop-types'

// Components
import CustomerForm from 'modules/CustomerEquipment/components/Form';

// Other
import useApi from 'hooks/useApi';

const CustomerEquipmentCreateScreen = ({ contract_id, onClose }) => {

    const { post: create, errors } = useApi('/customerequipment', false);

    const submit = async (values) => {

        create(values, 'Customer Equipment created!', '/customerequipment/');
    }


    return(
        <CustomerForm 
            errors={errors} 
            contract_id={contract_id}
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

CustomerEquipmentCreateScreen.propTypes = {
    contract_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
}

CustomerEquipmentCreateScreen.defaultProps = {
    contract_id: null,
	onClose: () => {alert('onClose is not set!')},
}

export default CustomerEquipmentCreateScreen;